module.exports = __webpack_public_path__ + "static/media/squared.4267d9d4.jpg";